import ConfirmPopover from '@/components/common/ConfirmPopover';
import { useDialogs } from '@/hooks/useDialogs';
import CancelIcon from '@mui/icons-material/Cancel';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Stack,
  TextField
} from '@mui/material';
import { ConfirmOptions } from 'material-ui-confirm';
import { FC, useState } from 'react';

type QueueMessagesDialogProps = {
  open: boolean;
  messages: string[];
  messageOptions: string[];
  onClose: (messages: string[]) => void;
};

const QueueMessagesDialog: FC<QueueMessagesDialogProps> = (props) => {
  const [selectedMessages, setSelectedMessages] = useState(props.messages);
  const [currentMessage, setCurrentMessage] = useState('');

  const { confirm } = useDialogs();

  const confirmExists: ConfirmOptions = {
    title: 'Message already exists',
    description: `This message already exists in the current Queue Messages list`,
    confirmationText: 'Ok',
    hideCancelButton: true
  };

  const handleOnClose = () => {
    setCurrentMessage('');
    props.onClose(selectedMessages);
  };

  const handleAddMessage = () => {
    if (selectedMessages.includes(currentMessage)) {
      confirm(confirmExists);
      return;
    }
    setSelectedMessages((messages) => [...messages, currentMessage]);
    setCurrentMessage('');
  };

  const handleOnDelete = (selectedMessage: string) => {
    setSelectedMessages(selectedMessages.filter((message) => message !== selectedMessage));
  };

  return (
    <Dialog open={props.open} onClose={handleOnClose} fullWidth maxWidth='xs' disableRestoreFocus>
      <DialogTitle>Queue Messages</DialogTitle>
      <DialogContent>
        {selectedMessages.map((selectedMessage) => (
          <DialogContentText>
            <code>{selectedMessage}</code>
            <ConfirmPopover
              text={
                <>
                  Delete <code>{selectedMessage}</code>?
                </>
              }
              onConfirm={() => handleOnDelete(selectedMessage)}
              icon={<CancelIcon />}
            />
          </DialogContentText>
        ))}
        <Stack direction={'row'} pt={1}>
          <TextField
            label='Message'
            value={currentMessage}
            onChange={(event) => setCurrentMessage(event.currentTarget.value)}
            fullWidth
            size='small'
            autoFocus
            onKeyDown={(e) => e.key === 'Enter' && currentMessage && handleAddMessage()}
            InputProps={{ autoComplete: 'off' }}
          />
          <Button onClick={() => currentMessage && handleAddMessage()}>Add</Button>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button color='secondary' onClick={handleOnClose}>
          {'Close'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default QueueMessagesDialog;
